
export default function getRegionBySubdomain(subdomain) {
  if (!subdomain) { return null }

  const region = Sti.Data.regions.find(region => region.subdomain === subdomain);

  return (region || null);
}
